import React from 'react';
import { Slide, toast as toastify } from 'react-toastify';

function ActionToast(props) {
  const { renderer: RenderAction, option = {} } = props;
  const {
    position = 'bottom-right',
    onClose = () => {},
    autoClose = false,
    hideProgressBar = true,
    closeOnClick = false,
    pauseOnHover = true,
    draggable = true,
    progress = undefined,
    closeButton = false,
    className = 'upload w400 br-5',
    transition = Slide
  } = option;
  return toastify(<RenderAction {...props} />, {
    position,
    autoClose,
    onClose,
    hideProgressBar,
    closeOnClick,
    pauseOnHover,
    draggable,
    progress,
    closeButton,
    className,
    transition
  });
}

export default ActionToast;
